import React, { memo } from "react";
import KTHomeHeader from "./c-components/home-header";
import { renderRoutes } from "react-router-config";
import KTWindowSizeContext from "../../common/context/windowSizeContext";
import withWindowSize from "@/components/higher-order/withWindowSize";
import {Helmet} from "react-helmet";

const KTHome = memo(({ route, windowSize }) => {

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Kustom Tickets",
    "url": "https://www.kustomtickets.com",
    "logo": "https://www.kustomtickets.com/logo192.png"
    };
  return (
    <>
    <Helmet>
    <script type="application/ld+json">
      {JSON.stringify(jsonLd)}
    </script>
    </Helmet>
    <KTWindowSizeContext.Provider value={{ windowSize: windowSize }}>
      <KTHomeHeader />
      {renderRoutes(route.routes)}
    </KTWindowSizeContext.Provider>
    </>
  );
});

export default withWindowSize(KTHome);
